import(/* webpackMode: "eager" */ "/vercel/path0/apps/blog/src/app/error.tsx");
